import { BuildType } from '@/services/ApiService';
import { QuerySkillParams, SkillModel } from '@/apiTypes/SkillsTypes';

export type QuerySkillsResponse = {
    rows: SkillModel[];
    count: number;
};

export const skillApiEndpoints = (build: BuildType) => ({
    querySkills: build.query<QuerySkillsResponse, QuerySkillParams>({
        query: params => ({
            url: 'skills/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: QuerySkillsResponse) => response,
    }),
});
